import 'javascripts/all_pages_styles.js'
import 'javascripts/all_pages.js'

if (window.dataLayer[0].mobileDevice) {
  import('stylesheets/vendors/comparison_mobile.less')
} else {
  import('stylesheets/vendors/comparison_desktop.less')

  if ($('.comparison-slider').length) {
    import('javascripts/gitb_easyslider.js')
      .then(module => module.comparisonSlider())
  }
}